module.exports = __webpack_public_path__ + "static/favicon-b73e264084c7d08773f0bc2f3fbe02c6.ico";